'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePage = exports.createPage = exports.fetchPageDonationCount = exports.fetchPage = exports.fetchPages = exports.deserializePage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _jsonDate = require('../../../utils/jsonDate');

var _jsonDate2 = _interopRequireDefault(_jsonDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var deserializePage = exports.deserializePage = function deserializePage(page) {
  var subdomain = (0, _client.isStaging)() ? 'www.staging' : 'www';
  var url = page.Link || 'https://' + subdomain + '.justgiving.com/fundraising/' + page.pageShortName;

  var getImage = function getImage() {
    if (page.pageImages && page.pageImages.length > 0) {
      return 'https://images' + subdomain.replace('www', '') + '.jg-cdn.com/image/' + page.pageImages[0];
    }

    return page.defaultImage || page.Logo || (0, _get2.default)(page, 'image.url') || (0, _get2.default)(page, 'images[0].url') || 'https://' + subdomain + '.justgiving.com/fundraising/images/user-profile/' + (0, _get2.default)(page, 'pageOwner.accountId');
  };

  return {
    active: !page.status && !page.pageStatus || [page.status, page.pageStatus].indexOf('Inactive') > -1,
    campaign: page.Subtext || page.eventId || page.EventId,
    campaignDate: (0, _jsonDate2.default)(page.eventDate) || page.EventDate,
    charity: page.charity || page.CharityId,
    coordinates: null,
    createdAt: (0, _jsonDate2.default)(page.createdDate) || page.CreatedDate,
    donationUrl: [url, 'donate'].join('/'),
    expired: (0, _jsonDate2.default)(page.expiryDate) && (0, _moment2.default)(page.expiryDate).isBefore(),
    groups: null,
    hasUpdatedImage: page.imageCount !== '1',
    id: page.pageId || page.Id,
    image: getImage(),
    name: page.title || page.pageTitle || page.Name || (0, _get2.default)(page, 'pageOwner.fullName'),
    owner: page.owner || page.OwnerFullName || (0, _get2.default)(page, 'pageOwner.fullName'),
    raised: parseFloat(page.grandTotalRaisedExcludingGiftAid || page.Amount || page.raisedAmount || page.amountRaised || 0),
    slug: page.pageShortName,
    story: page.story || page.ProfileWhat || page.ProfileWhy,
    target: parseFloat(page.fundraisingTarget || page.TargetAmount || page.targetAmount || page.target || 0),
    teamPageId: page.teams && page.teams.length > 0 ? page.teams[0].teamGuid : null,
    teamShortName: page.teams && page.teams.length > 0 ? page.teams[0].teamShortName : null,
    url: url,
    uuid: null
  };
};

var fetchPages = function fetchPages() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var allPages = params.allPages,
      _params$authType = params.authType,
      authType = _params$authType === undefined ? 'Basic' : _params$authType,
      campaign = params.campaign,
      charity = params.charity,
      event = params.event,
      token = params.token,
      userPages = params.userPages,
      args = _objectWithoutProperties(params, ['allPages', 'authType', 'campaign', 'charity', 'event', 'token', 'userPages']);

  if (userPages && token) {
    return (0, _client.get)('/v1/fundraising/pages', {}, {}, {
      headers: {
        Authorization: [authType, token].join(' ')
      }
    });
  }

  if (allPages && event) {
    var mappings = { limit: 'pageSize' };

    return (0, _client.get)('/v1/event/' + (0, _params.getUID)(event) + '/pages', args, { mappings: mappings }).then(function (response) {
      return response.fundraisingPages;
    });
  }

  if (allPages && campaign && charity) {
    return (0, _client.get)('/v1/campaigns/' + (0, _params.getShortName)(charity) + '/' + (0, _params.getShortName)(campaign) + '/pages').then(function (response) {
      return response.fundraisingPages;
    });
  }

  if (campaign && !event) {
    return _client.servicesAPI.get('/v1/justgiving/campaigns/' + (0, _params.getUID)(campaign) + '/leaderboard', {
      params: args
    }).then(function (_ref) {
      var data = _ref.data;
      return data.results;
    });
  }

  return (0, _client.get)('/v1/onesearch', _extends({
    campaignId: (0, _params.getUID)(campaign),
    charityId: (0, _params.getUID)(charity),
    eventId: (0, _params.getUID)(event),
    i: 'Fundraiser'
  }, args)).then(function (response) {
    return response.GroupedResults && response.GroupedResults.length && response.GroupedResults[0].Results || [];
  });
};

exports.fetchPages = fetchPages;
var fetchPage = exports.fetchPage = function fetchPage() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var slug = arguments[1];

  var endpoint = slug ? 'pages' : isNaN(page) ? 'pages' : 'pagebyid';
  return (0, _client.get)('/v1/fundraising/' + endpoint + '/' + page);
};

var fetchPageDonationCount = exports.fetchPageDonationCount = function fetchPageDonationCount() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.get)('/v1/fundraising/pages/' + page + '/donations').then(function (data) {
    return data.pagination.totalResults;
  });
};

var createPage = exports.createPage = function createPage(_ref2) {
  var _ref2$charityId = _ref2.charityId,
      charityId = _ref2$charityId === undefined ? (0, _params.required)() : _ref2$charityId,
      _ref2$slug = _ref2.slug,
      slug = _ref2$slug === undefined ? (0, _params.required)() : _ref2$slug,
      _ref2$title = _ref2.title,
      title = _ref2$title === undefined ? (0, _params.required)() : _ref2$title,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token,
      activityType = _ref2.activityType,
      attribution = _ref2.attribution,
      _ref2$authType = _ref2.authType,
      authType = _ref2$authType === undefined ? 'Basic' : _ref2$authType,
      campaignId = _ref2.campaignId,
      campaignGuid = _ref2.campaignGuid,
      causeId = _ref2.causeId,
      charityFunded = _ref2.charityFunded,
      _ref2$charityOptIn = _ref2.charityOptIn,
      charityOptIn = _ref2$charityOptIn === undefined ? false : _ref2$charityOptIn,
      companyAppealId = _ref2.companyAppealId,
      consistentErrorResponses = _ref2.consistentErrorResponses,
      currency = _ref2.currency,
      customCodes = _ref2.customCodes,
      eventDate = _ref2.eventDate,
      eventId = _ref2.eventId,
      eventName = _ref2.eventName,
      expiryDate = _ref2.expiryDate,
      giftAid = _ref2.giftAid,
      images = _ref2.images,
      reference = _ref2.reference,
      rememberedPersonReference = _ref2.rememberedPersonReference,
      story = _ref2.story,
      summaryWhat = _ref2.summaryWhat,
      summaryWhy = _ref2.summaryWhy,
      target = _ref2.target,
      teamId = _ref2.teamId,
      theme = _ref2.theme,
      videos = _ref2.videos;

  return (0, _client.put)('/v1/fundraising/pages', {
    activityType: activityType,
    attribution: attribution,
    campaignGuid: campaignGuid || campaignId,
    causeId: causeId,
    charityFunded: charityFunded,
    charityId: charityId,
    charityOptIn: charityOptIn,
    companyAppealId: companyAppealId,
    consistentErrorResponses: consistentErrorResponses,
    currency: currency,
    customCodes: customCodes,
    eventDate: eventDate,
    eventId: eventId,
    eventName: eventName,
    expiryDate: expiryDate,
    images: images,
    isGiftAidable: giftAid,
    pageShortName: slug,
    pageStory: story,
    pageSummaryWhat: summaryWhat,
    pageSummaryWhy: summaryWhy,
    pageTitle: title,
    reference: reference,
    rememberedPersonReference: rememberedPersonReference,
    targetAmount: target,
    teamId: teamId,
    theme: theme,
    videos: videos
  }, {
    headers: {
      Authorization: [authType, token].join(' ')
    }
  });
};

var updatePage = exports.updatePage = function updatePage() {
  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var _ref3 = arguments[1];
  var _ref3$token = _ref3.token,
      token = _ref3$token === undefined ? (0, _params.required)() : _ref3$token,
      attribution = _ref3.attribution,
      _ref3$authType = _ref3.authType,
      authType = _ref3$authType === undefined ? 'Basic' : _ref3$authType,
      image = _ref3.image,
      name = _ref3.name,
      story = _ref3.story,
      summaryWhat = _ref3.summaryWhat,
      summaryWhy = _ref3.summaryWhy,
      target = _ref3.target;

  var config = { headers: { Authorization: [authType, token].join(' ') } };

  return Promise.all([attribution && (0, _client.put)('/v1/fundraising/pages/' + slug + '/attribution', { attribution: attribution }, config), image && (0, _client.put)('/v1/fundraising/pages/' + slug + '/images', { url: image, isDefault: true }, config), name && (0, _client.put)('/v1/fundraising/pages/' + slug + '/pagetitle', { pageTitle: name }, config), story && (0, _client.put)('/v1/fundraising/pages/' + slug + '/pagestory', { story: story }, config), target && (0, _client.put)('/v1/fundraising/pages/' + slug + '/target', { amount: target }, config), (summaryWhat || summaryWhy) && (0, _client.put)('/v1/fundraising/pages/' + slug + '/summary', {
    pageSummaryWhat: summaryWhat,
    pageSummaryWhy: summaryWhy
  }, config)].filter(function (promise) {
    return promise;
  }));
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/pages/justgiving/index.js
// module id = 1423
// module chunks = 0